/**
 * Casa Kalā — Main Application Script
 */

document.addEventListener('DOMContentLoaded', () => {
  // ==========================================
  // 1. Mobile Menu Drawer Toggle
  // ==========================================
  const mobileToggle = document.getElementById('mobile-toggle');
  const mobileDrawer = document.getElementById('mobile-drawer');
  const mobileClose = document.getElementById('mobile-close');

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', () => {
      mobileDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', () => {
      mobileDrawer.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // Close drawer when clicking a mobile nav link
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-list a');
  mobileNavLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (mobileDrawer) {
        mobileDrawer.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  // ==========================================
  // 2. Newsletter Form Handling
  // ==========================================
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const emailInput = newsletterForm.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        alert('Thank you for subscribing to Casa Kalā!');
        emailInput.value = '';
      }
    });
  }

  // ==========================================
  // 3. Bestsellers Add to Cart Interactivity & Toast
  // ==========================================
  const cartBadge = document.querySelector('.cart-badge');
  let cartCount = 0;

  // Create Toast Element for feedback
  const toastContainer = document.createElement('div');
  toastContainer.className = 'cart-toast';
  toastContainer.id = 'cart-toast';
  toastContainer.innerHTML = `
    <span class="cart-toast__icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span class="cart-toast__message">Item added to bag!</span>
  `;
  document.body.appendChild(toastContainer);

  let toastTimeout;

  function showToast(productTitle) {
    const toastMsg = toastContainer.querySelector('.cart-toast__message');
    if (toastMsg) {
      toastMsg.textContent = `"${productTitle}" added to your bag`;
    }
    toastContainer.classList.add('show');

    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(() => {
      toastContainer.classList.remove('show');
    }, 2800);
  }


  // ==========================================
  // 4. Bestsellers Slider Logic
  // ==========================================
  const bestsellersSlider = document.querySelector(
    '[id^="bestsellers-slider-"]'
  ) || document.getElementById('bestsellers-slider');

  const bestsellersPrev = document.querySelector(
    '[id^="bestsellers-prev-"]'
  ) || document.getElementById('bestsellers-prev');

  const bestsellersNext = document.querySelector(
    '[id^="bestsellers-next-"]'
  ) || document.getElementById('bestsellers-next');

  const bestsellersNav = document.querySelector(
    '[id^="bestsellers-nav-"]'
  ) || document.getElementById('bestsellers-nav');

  if (bestsellersSlider) {
    let autoScrollInterval = null;
    const AUTO_SCROLL_DELAY = 3500; // Autoscroll every 3.5 seconds

    function startAutoScroll() {
      stopAutoScroll();
      autoScrollInterval = setInterval(() => {
        const scrollLeft = Math.round(bestsellersSlider.scrollLeft);
        const maxScroll = Math.round(bestsellersSlider.scrollWidth - bestsellersSlider.clientWidth);

        if (maxScroll <= 5) return;

        if (scrollLeft >= maxScroll - 10) {
          // Loop back to beginning when reaching the end
          bestsellersSlider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          bestsellersSlider.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        }
      }, AUTO_SCROLL_DELAY);
    }

    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
    }

    function restartAutoScroll() {
      stopAutoScroll();
      startAutoScroll();
    }

    function checkSliderMode() {
      const windowWidth = window.innerWidth;
      const isDesktop = windowWidth > 1024;
      const isMobileSmall = windowWidth <= 479;
      const cards = bestsellersSlider.querySelectorAll('.bestseller-card');
      const cardCount = cards.length;

      // Condition:
      // 1. On desktop (> 1024px): Slider enables ONLY if cardCount > 4 (static grid if <= 4).
      // 2. On tablet (480px - 1024px): Slider enables if cardCount > 2 (2 slides per view).
      // 3. On small mobile (<= 479px): Slider enables if cardCount > 1 (1 slide per view).
      let enableSlider = false;
      if (isDesktop) {
        enableSlider = cardCount > 4;
      } else if (isMobileSmall) {
        enableSlider = cardCount > 1;
      } else {
        enableSlider = cardCount > 2;
      }

      if (enableSlider) {
        bestsellersSlider.classList.add('is-slider');
        if (bestsellersNav) bestsellersNav.style.display = 'flex';
        updateNavButtons();
        startAutoScroll();
      } else {
        bestsellersSlider.classList.remove('is-slider');
        bestsellersSlider.scrollLeft = 0; // Reset scroll position in static grid mode
        if (bestsellersNav) bestsellersNav.style.display = 'none';
        stopAutoScroll();
      }
    }

    function updateNavButtons() {
      if (!bestsellersPrev || !bestsellersNext) return;
      const scrollLeft = Math.round(bestsellersSlider.scrollLeft);
      const maxScroll = Math.round(bestsellersSlider.scrollWidth - bestsellersSlider.clientWidth);

      bestsellersPrev.disabled = scrollLeft <= 5;
      bestsellersNext.disabled = scrollLeft >= maxScroll - 5;
    }

    function getScrollStep() {
      const windowWidth = window.innerWidth;
      const firstCard = bestsellersSlider.querySelector('.bestseller-card');
      if (!firstCard) return bestsellersSlider.clientWidth;
      const gap = windowWidth > 1024 ? 24 : 16;
      // Scroll 1 card width at a time for desktop & small mobile (<=479px); scroll 2 cards for tablet (480px-1024px)
      const slidesToScroll = (windowWidth > 1024 || windowWidth <= 479) ? 1 : 2;
      return (firstCard.offsetWidth + gap) * slidesToScroll;
    }

    if (bestsellersPrev) {
      bestsellersPrev.addEventListener('click', () => {
        bestsellersSlider.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        restartAutoScroll();
      });
    }

    if (bestsellersNext) {
      bestsellersNext.addEventListener('click', () => {
        const scrollLeft = Math.round(bestsellersSlider.scrollLeft);
        const maxScroll = Math.round(bestsellersSlider.scrollWidth - bestsellersSlider.clientWidth);
        if (scrollLeft >= maxScroll - 10) {
          bestsellersSlider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          bestsellersSlider.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        }
        restartAutoScroll();
      });
    }

    // Pause autoscroll when user hovers or touches the slider
    bestsellersSlider.addEventListener('mouseenter', stopAutoScroll);
    bestsellersSlider.addEventListener('mouseleave', startAutoScroll);
    bestsellersSlider.addEventListener('touchstart', stopAutoScroll, { passive: true });
    bestsellersSlider.addEventListener('touchend', () => {
      setTimeout(startAutoScroll, 2000);
    }, { passive: true });

    bestsellersSlider.addEventListener('scroll', updateNavButtons, { passive: true });
    window.addEventListener('resize', checkSliderMode);

    checkSliderMode();
  }

  // ==========================================
  // 5. Curated Hampers Slider Logic
  // ==========================================
  const curatedSlider = document.getElementById('curated-slider') || document.querySelector('[id^="curated-slider-"]');
  const curatedPrev = document.getElementById('curated-prev') || document.querySelector('[id^="curated-prev-"]');
  const curatedNext = document.getElementById('curated-next') || document.querySelector('[id^="curated-next-"]');
  const curatedNav = document.getElementById('curated-nav') || document.querySelector('[id^="curated-nav-"]');

  if (curatedSlider) {
    function checkCuratedSliderMode() {
      const windowWidth = window.innerWidth;
      // Convert to slider below 1200px screen size
      const isSliderMode = windowWidth < 1200;

      if (isSliderMode) {
        curatedSlider.classList.add('is-slider');
        if (curatedNav) curatedNav.style.display = 'flex';
        updateCuratedNavButtons();
      } else {
        curatedSlider.classList.remove('is-slider');
        if (curatedNav) curatedNav.style.display = 'none';
      }
    }

    function updateCuratedNavButtons() {
      if (!curatedPrev || !curatedNext) return;
      const scrollLeft = Math.round(curatedSlider.scrollLeft);
      const maxScroll = Math.round(curatedSlider.scrollWidth - curatedSlider.clientWidth);

      curatedPrev.disabled = scrollLeft <= 5;
      curatedNext.disabled = scrollLeft >= maxScroll - 5;
    }

    function getCuratedScrollStep() {
      const firstCard = curatedSlider.querySelector('.curated-card');
      if (!firstCard) return curatedSlider.clientWidth;
      const windowWidth = window.innerWidth;
      const gap = windowWidth <= 767 ? 16 : 20;
      // Requirement: 1 card scroll at a time
      return firstCard.offsetWidth + gap;
    }

    if (curatedPrev) {
      curatedPrev.addEventListener('click', () => {
        curatedSlider.scrollBy({ left: -getCuratedScrollStep(), behavior: 'smooth' });
      });
    }

    if (curatedNext) {
      curatedNext.addEventListener('click', () => {
        curatedSlider.scrollBy({ left: getCuratedScrollStep(), behavior: 'smooth' });
      });
    }

    curatedSlider.addEventListener('scroll', updateCuratedNavButtons, { passive: true });
    window.addEventListener('resize', checkCuratedSliderMode);

    checkCuratedSliderMode();
  }

  // ==========================================
  // 6. About Us — Artisan Cascade Slider (Interactive 3D Carousel)
  // ==========================================
  function initArtisanSlider() {
    const artisanSlider = document.getElementById('artisan-slider') || document.querySelector('.artisan-slider-track');
    const artisanPrev = document.getElementById('artisan-prev') || document.querySelector('.slider-arrow#artisan-prev');
    const artisanNext = document.getElementById('artisan-next') || document.querySelector('.slider-arrow#artisan-next');
    const artisanCounter = document.getElementById('artisan-counter');
    const artisanDots = document.querySelectorAll('.artisan-dot');

    if (!artisanSlider) return;

    const cards = Array.from(artisanSlider.querySelectorAll('.artisan-card'));
    const totalCards = cards.length;
    if (totalCards === 0) return;

    let activeIndex = 0; // Starts with first slide active in center
    let autoplayTimer = null;

    function getLayoutMetrics() {
      const w = window.innerWidth;
      if (w <= 767) {
        return {
          step1: 155,
          step2: 275,
          scaleCenter: 1.0,
          scaleMid: 0.82,
          scaleFar: 0.66,
          opacityFar: 0.5
        };
      } else if (w <= 1024) {
        return {
          step1: 220,
          step2: 395,
          scaleCenter: 1.0,
          scaleMid: 0.82,
          scaleFar: 0.68,
          opacityFar: 0.72
        };
      } else {
        return {
          step1: 285,
          step2: 515,
          scaleCenter: 1.0,
          scaleMid: 0.82,
          scaleFar: 0.68,
          opacityFar: 0.75
        };
      }
    }

    function updateArtisanSlider(skipTransition = false) {
      const { step1, step2, scaleCenter, scaleMid, scaleFar, opacityFar } = getLayoutMetrics();

      cards.forEach((card, i) => {
        let diff = i - activeIndex;
        // Circular distance wrapping
        if (diff > totalCards / 2) diff -= totalCards;
        if (diff < -totalCards / 2) diff += totalCards;

        if (skipTransition) {
          card.style.transition = 'none';
        } else {
          card.style.transition = '';
        }

        card.classList.remove('is-active', 'is-prev', 'is-next', 'is-far-prev', 'is-far-next', 'is-hidden');

        if (diff === 0) {
          // Center Active Slide (Hero card)
          card.classList.add('is-active');
          card.style.transform = `translate(-50%, -50%) translateX(0px) scale(${scaleCenter})`;
          card.style.zIndex = '10';
          card.style.opacity = '1';
          card.style.pointerEvents = 'auto';
        } else if (diff === 1) {
          // Immediate Right (Medium)
          card.classList.add('is-next');
          card.style.transform = `translate(-50%, -50%) translateX(${step1}px) scale(${scaleMid})`;
          card.style.zIndex = '6';
          card.style.opacity = '0.92';
          card.style.pointerEvents = 'auto';
        } else if (diff === -1) {
          // Immediate Left (Medium)
          card.classList.add('is-prev');
          card.style.transform = `translate(-50%, -50%) translateX(-${step1}px) scale(${scaleMid})`;
          card.style.zIndex = '6';
          card.style.opacity = '0.92';
          card.style.pointerEvents = 'auto';
        } else if (diff === 2) {
          // Outer Right (Small)
          card.classList.add('is-far-next');
          card.style.transform = `translate(-50%, -50%) translateX(${step2}px) scale(${scaleFar})`;
          card.style.zIndex = '3';
          card.style.opacity = String(opacityFar);
          card.style.pointerEvents = 'auto';
        } else if (diff === -2) {
          // Outer Left (Small)
          card.classList.add('is-far-prev');
          card.style.transform = `translate(-50%, -50%) translateX(-${step2}px) scale(${scaleFar})`;
          card.style.zIndex = '3';
          card.style.opacity = String(opacityFar);
          card.style.pointerEvents = 'auto';
        } else {
          // Off-screen (Hidden)
          card.classList.add('is-hidden');
          const offX = diff > 0 ? step2 + 160 : -(step2 + 160);
          card.style.transform = `translate(-50%, -50%) translateX(${offX}px) scale(0.55)`;
          card.style.zIndex = '1';
          card.style.opacity = '0';
          card.style.pointerEvents = 'none';
        }
      });

      // Update Counter: e.g. 01 / 09
      if (artisanCounter) {
        const cur = String(activeIndex + 1).padStart(2, '0');
        const tot = String(totalCards).padStart(2, '0');
        artisanCounter.textContent = `${cur} / ${tot}`;
      }

      // Update Dots
      artisanDots.forEach((dot, idx) => {
        dot.classList.toggle('active', idx === activeIndex);
      });
    }

    function nextSlide() {
      activeIndex = (activeIndex + 1) % totalCards;
      updateArtisanSlider();
    }

    function prevSlide() {
      activeIndex = (activeIndex - 1 + totalCards) % totalCards;
      updateArtisanSlider();
    }

    if (artisanNext) {
      artisanNext.disabled = false;
      artisanNext.onclick = nextSlide;
    }

    if (artisanPrev) {
      artisanPrev.disabled = false;
      artisanPrev.onclick = prevSlide;
    }

    // Direct card click: click any card to make it active center
    cards.forEach((card, i) => {
      card.onclick = () => {
        if (i !== activeIndex) {
          activeIndex = i;
          updateArtisanSlider();
        }
      };
    });

    // Dot click handling
    artisanDots.forEach((dot) => {
      dot.onclick = () => {
        const slideIndex = parseInt(dot.getAttribute('data-slide') || '0', 10);
        if (slideIndex >= 0 && slideIndex < totalCards) {
          activeIndex = slideIndex;
          updateArtisanSlider();
        }
      };
    });

    // Touch swipe support
    let touchStartX = 0;
    const sliderParent = artisanSlider.parentElement;

    if (sliderParent) {
      sliderParent.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      sliderParent.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const threshold = 40;
        if (touchStartX - touchEndX > threshold) {
          nextSlide();
        } else if (touchEndX - touchStartX > threshold) {
          prevSlide();
        }
      }, { passive: true });
    }

    // Keyboard navigation
    window.addEventListener('keydown', (e) => {
      if (document.activeElement && ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName)) return;
      if (e.key === 'ArrowRight') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
    });

    // Autoplay with hover pause
    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(nextSlide, 4500);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (sliderParent) {
      sliderParent.addEventListener('mouseenter', stopAutoplay);
      sliderParent.addEventListener('mouseleave', startAutoplay);
    }

    window.addEventListener('resize', () => updateArtisanSlider());
    updateArtisanSlider();
    startAutoplay();
  }

  // Initialize Artisan Slider
  initArtisanSlider();

  // Support Shopify Theme Customizer dynamic section reloads
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && (e.target.querySelector('#artisan-slider') || e.target.id === 'artisan-slider')) {
      initArtisanSlider();
    }
  });

  // ==========================================
  // 7. Contact Us Page Interactivity & Modals
  // ==========================================
  function initContactPage() {
    const contactForm = document.getElementById('contact-form') || document.querySelector('form[action*="/contact"]');
    const submitBtn = document.getElementById('contact-submit-btn');
    const successModal = document.getElementById('contact-success-modal');
    const modalCloseBtn = document.getElementById('modal-close-btn');
    const modalOkBtn = document.getElementById('modal-ok-btn');
    const hasPostedSuccess = document.querySelector('.contact-form__success') || window.location.search.includes('contact_posted=true');

    // Auto-show success modal if Shopify posted successfully
    if (hasPostedSuccess && successModal) {
      successModal.classList.add('active');
      successModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeSuccessModal() {
      if (successModal) {
        successModal.classList.remove('active');
        successModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeSuccessModal);
    if (modalOkBtn) modalOkBtn.addEventListener('click', closeSuccessModal);
    if (successModal) {
      successModal.addEventListener('click', (e) => {
        if (e.target === successModal) closeSuccessModal();
      });
    }

    // FAQs Modal Handling
    const faqModal = document.getElementById('contact-faq-modal');
    const openFaqsBtn = document.getElementById('open-faqs-btn');
    const footerFaqLink = document.getElementById('footer-faq-link');
    const faqCloseBtn = document.getElementById('faq-close-btn');
    const faqOkBtn = document.getElementById('faq-ok-btn');

    function openFaqModal() {
      if (faqModal) {
        faqModal.classList.add('active');
        faqModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeFaqModal() {
      if (faqModal) {
        faqModal.classList.remove('active');
        faqModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    if (openFaqsBtn) {
      openFaqsBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openFaqModal();
      });
    }

    if (footerFaqLink) {
      footerFaqLink.addEventListener('click', (e) => {
        e.preventDefault();
        openFaqModal();
      });
    }

    if (faqCloseBtn) faqCloseBtn.addEventListener('click', closeFaqModal);
    if (faqOkBtn) faqOkBtn.addEventListener('click', closeFaqModal);
    if (faqModal) {
      faqModal.addEventListener('click', (e) => {
        if (e.target === faqModal) closeFaqModal();
      });
    }

    // Quick Links Card Click Action
    const quickCards = document.querySelectorAll('.contact-quicklink-card');
    quickCards.forEach(card => {
      card.addEventListener('click', () => {
        const topic = card.getAttribute('data-topic');
        const subjectSelect = document.getElementById('ContactFormSubject') || document.getElementById('subject');
        if (subjectSelect) {
          if (topic === 'shipping' || topic === 'returns') {
            subjectSelect.value = 'Order Status & Tracking';
          } else if (topic === 'payments') {
            subjectSelect.value = 'General Enquiry';
          } else if (topic === 'custom') {
            subjectSelect.value = 'Custom & Bespoke Hampers';
          }
        }
        openFaqModal();
      });
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }
      });
    });

    // Escape key to close any modal
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeSuccessModal();
        closeFaqModal();
      }
    });
  }

  initContactPage();

  // ==========================================
  // 8. Corporate Gifting — Fade-in Image Slider
  // ==========================================
  function initCorporateSlider() {
    const sliderWraps = document.querySelectorAll('.corp-slider-wrap');
    if (sliderWraps.length === 0) return;

    sliderWraps.forEach((wrap) => {
      const slides = Array.from(wrap.querySelectorAll('.corp-slide'));
      if (slides.length <= 1) return;

      const prevBtn = wrap.querySelector('#corp-prev-btn') || wrap.querySelector('.corp-slider__arrow--prev');
      const nextBtn = wrap.querySelector('#corp-next-btn') || wrap.querySelector('.corp-slider__arrow--next');
      const dots = Array.from(wrap.querySelectorAll('.corp-dot'));
      const counter = wrap.querySelector('#corp-counter') || wrap.querySelector('.corp-slider__counter');

      let activeIndex = slides.findIndex((s) => s.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      let autoplayTimer = null;
      const AUTOPLAY_DELAY = 4500;

      function goToSlide(targetIndex) {
        if (targetIndex === activeIndex) return;

        // Deactivate current slide
        slides[activeIndex].classList.remove('is-active');
        if (dots[activeIndex]) dots[activeIndex].classList.remove('is-active');

        // Circular index calculation
        activeIndex = (targetIndex + slides.length) % slides.length;

        // Activate new slide with fade-in effect
        slides[activeIndex].classList.add('is-active');
        if (dots[activeIndex]) dots[activeIndex].classList.add('is-active');

        // Update counter
        if (counter) {
          const cur = String(activeIndex + 1).padStart(2, '0');
          const tot = String(slides.length).padStart(2, '0');
          counter.textContent = `${cur} / ${tot}`;
        }
      }

      function nextSlide() {
        goToSlide(activeIndex + 1);
      }

      function prevSlide() {
        goToSlide(activeIndex - 1);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          nextSlide();
          restartAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          prevSlide();
          restartAutoplay();
        });
      }

      dots.forEach((dot, idx) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goToSlide(idx);
          restartAutoplay();
        });
      });

      // Keyboard navigation
      window.addEventListener('keydown', (e) => {
        if (document.activeElement && ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName)) return;
        if (e.key === 'ArrowRight') {
          nextSlide();
          restartAutoplay();
        } else if (e.key === 'ArrowLeft') {
          prevSlide();
          restartAutoplay();
        }
      });

      // Touch swipe support (fade transition triggers on swipe)
      let touchStartX = 0;
      let touchStartY = 0;

      wrap.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        stopAutoplay();
      }, { passive: true });

      wrap.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const touchEndY = e.changedTouches[0].screenY;
        const diffX = touchStartX - touchEndX;
        const diffY = touchStartY - touchEndY;

        // Only register horizontal swipes
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
          if (diffX > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
        startAutoplay();
      }, { passive: true });

      // Autoplay with hover pause
      function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(nextSlide, AUTOPLAY_DELAY);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function restartAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      wrap.addEventListener('mouseenter', stopAutoplay);
      wrap.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  }

  initCorporateSlider();

  // ==========================================
  // 9. Reusable FAQ Accordion & FAQ Hub
  // ==========================================
  function initFaqAccordion() {
    const accordions = document.querySelectorAll('.faq-accordion, [data-faq-accordion]');
    if (!accordions.length) return;

    accordions.forEach((accordion) => {
      if (accordion.dataset.faqInitialized === 'true') return;
      accordion.dataset.faqInitialized = 'true';

      const isExclusive = accordion.getAttribute('data-accordion-exclusive') !== 'false';
      const items = accordion.querySelectorAll('.faq-item');

      items.forEach((item) => {
        const trigger = item.querySelector('.faq-trigger');
        const body = item.querySelector('.faq-body');

        if (!trigger || !body) return;

        // Auto-assign IDs and ARIA attributes if not set
        const uniqueId = body.id || `faq-body-${Math.random().toString(36).substr(2, 9)}`;
        body.id = uniqueId;
        body.setAttribute('role', 'region');
        trigger.setAttribute('aria-controls', uniqueId);

        const isOpen = item.classList.contains('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        body.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        // Click Handler
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const willOpen = !item.classList.contains('is-open');

          if (isExclusive && willOpen) {
            items.forEach((sibling) => {
              if (sibling !== item && sibling.classList.contains('is-open')) {
                sibling.classList.remove('is-open');
                const sibTrigger = sibling.querySelector('.faq-trigger');
                const sibBody = sibling.querySelector('.faq-body');
                if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
                if (sibBody) sibBody.setAttribute('aria-hidden', 'true');
              }
            });
          }

          if (willOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            body.setAttribute('aria-hidden', 'false');
          } else {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            body.setAttribute('aria-hidden', 'true');
          }
        });

        // Accessible Keyboard Navigation
        trigger.addEventListener('keydown', (e) => {
          const triggers = Array.from(accordion.querySelectorAll('.faq-trigger')).filter(t => t.offsetParent !== null);
          const currentIndex = triggers.indexOf(trigger);

          if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % triggers.length;
            triggers[nextIndex].focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = (currentIndex - 1 + triggers.length) % triggers.length;
            triggers[prevIndex].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            triggers[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            triggers[triggers.length - 1].focus();
          }
        });
      });
    });

    // Category Filter Pills
    const filterButtons = document.querySelectorAll('[data-faq-filter]');
    const allFaqItems = document.querySelectorAll('.faq-accordion .faq-item');
    const emptyState = document.querySelector('.faq-empty-state');
    const searchInput = document.querySelector('.faq-search-input');

    if (filterButtons.length) {
      filterButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          filterButtons.forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          applyFaqFilterAndSearch();
        });
      });
    }

    // Live Search Input
    if (searchInput) {
      const clearBtn = document.querySelector('.faq-search-clear');

      searchInput.addEventListener('input', () => {
        if (clearBtn) {
          clearBtn.classList.toggle('is-visible', searchInput.value.trim().length > 0);
        }
        applyFaqFilterAndSearch();
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          searchInput.value = '';
          clearBtn.classList.remove('is-visible');
          applyFaqFilterAndSearch();
          searchInput.focus();
        });
      }
    }

    function applyFaqFilterAndSearch() {
      const activeFilterBtn = document.querySelector('[data-faq-filter].is-active');
      const activeCategory = activeFilterBtn ? activeFilterBtn.getAttribute('data-faq-filter') : 'all';
      const searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : '';

      let visibleCount = 0;

      allFaqItems.forEach((item) => {
        const itemCategory = item.getAttribute('data-category') || '';
        const questionText = (item.querySelector('.faq-trigger__text')?.textContent || '').toLowerCase();
        const answerText = (item.querySelector('.faq-body__content')?.textContent || '').toLowerCase();

        const matchesCategory = activeCategory === 'all' || itemCategory === activeCategory;
        const matchesSearch = !searchTerm || questionText.includes(searchTerm) || answerText.includes(searchTerm);

        if (matchesCategory && matchesSearch) {
          item.style.display = '';
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
      });

      // Toggle parent .faq-group containers when separated by category headings
      const faqGroups = document.querySelectorAll('.faq-group');
      if (faqGroups.length) {
        faqGroups.forEach((group) => {
          const groupItems = group.querySelectorAll('.faq-item');
          const hasVisible = Array.from(groupItems).some((it) => it.style.display !== 'none');
          group.style.display = hasVisible ? '' : 'none';
        });
      }

      if (emptyState) {
        emptyState.classList.toggle('is-visible', visibleCount === 0);
      }
    }

    // Deep Linking Support (URL hash e.g. faq.html#corporate)
    if (window.location.hash) {
      const targetHash = window.location.hash.substring(1);
      const targetItem = document.getElementById(targetHash) || document.querySelector(`[data-faq-id="${targetHash}"]`);
      if (targetItem) {
        const trigger = targetItem.querySelector('.faq-trigger');
        if (trigger) {
          setTimeout(() => {
            trigger.click();
            targetItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 250);
        }
      }
    }
  }

  initFaqAccordion();

  // ==========================================
  // 10. Testimonials & Patron Stories Slider
  // ==========================================
  function initTestimonialsSlider() {
    const slider = document.getElementById('testimonials-slider') || document.querySelector('.testimonials-track');
    if (!slider) return;

    const prevBtn = document.getElementById('testimonials-prev') || document.querySelector('.testimonials-nav .slider-arrow--prev');
    const nextBtn = document.getElementById('testimonials-next') || document.querySelector('.testimonials-nav .slider-arrow--next');
    const dotsWrap = document.getElementById('testimonials-dots') || document.querySelector('.testimonials-dots');
    const cards = Array.from(slider.querySelectorAll('.testimonial-card'));

    if (cards.length === 0) return;

    let autoScrollTimer = null;
    let isInteracting = false;

    // Create pagination dots dynamically if container exists
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `testimonials-dot${idx === 0 ? ' is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to testimonial ${idx + 1}`);
        dot.setAttribute('data-index', idx);
        dot.addEventListener('click', () => {
          scrollToCard(idx);
          restartAutoScroll();
        });
        dotsWrap.appendChild(dot);
      });
    }

    function getCardStep() {
      const firstCard = cards[0];
      if (!firstCard) return slider.clientWidth * 0.8;
      const gap = 24;
      return firstCard.offsetWidth + gap;
    }

    function scrollToCard(index) {
      const targetCard = cards[index];
      if (!targetCard) return;
      slider.scrollTo({
        left: targetCard.offsetLeft - slider.offsetLeft,
        behavior: 'smooth'
      });
    }

    function updateControls() {
      const scrollLeft = Math.round(slider.scrollLeft);
      const maxScroll = Math.round(slider.scrollWidth - slider.clientWidth);

      if (prevBtn) prevBtn.disabled = scrollLeft <= 8;
      if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll - 8;

      // Update active dot based on card in view
      if (dotsWrap) {
        const dots = dotsWrap.querySelectorAll('.testimonials-dot');
        let activeIdx = 0;
        let minDiff = Infinity;

        cards.forEach((card, idx) => {
          const cardLeft = card.offsetLeft - slider.offsetLeft;
          const diff = Math.abs(cardLeft - scrollLeft);
          if (diff < minDiff) {
            minDiff = diff;
            activeIdx = idx;
          }
        });

        dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === activeIdx);
        });
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        slider.scrollBy({ left: -getCardStep(), behavior: 'smooth' });
        restartAutoScroll();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const scrollLeft = Math.round(slider.scrollLeft);
        const maxScroll = Math.round(slider.scrollWidth - slider.clientWidth);
        if (scrollLeft >= maxScroll - 12) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: getCardStep(), behavior: 'smooth' });
        }
        restartAutoScroll();
      });
    }

    // Drag-to-scroll implementation
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - slider.offsetLeft;
      startScrollLeft = slider.scrollLeft;
      stopAutoScroll();
    });

    window.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
        setTimeout(startAutoScroll, 2500);
      }
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.4;
      slider.scrollLeft = startScrollLeft - walk;
    });

    // Touch & Hover Autoplay behavior
    function startAutoScroll() {
      if (autoScrollTimer || isInteracting || cards.length <= 1) return;
      autoScrollTimer = setInterval(() => {
        const scrollLeft = Math.round(slider.scrollLeft);
        const maxScroll = Math.round(slider.scrollWidth - slider.clientWidth);
        if (scrollLeft >= maxScroll - 12) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: getCardStep(), behavior: 'smooth' });
        }
      }, 5500);
    }

    function stopAutoScroll() {
      if (autoScrollTimer) {
        clearInterval(autoScrollTimer);
        autoScrollTimer = null;
      }
    }

    function restartAutoScroll() {
      stopAutoScroll();
      setTimeout(startAutoScroll, 3000);
    }

    slider.addEventListener('mouseenter', () => {
      isInteracting = true;
      stopAutoScroll();
    });

    slider.addEventListener('mouseleave', () => {
      isInteracting = false;
      startAutoScroll();
    });

    slider.addEventListener('touchstart', () => {
      isInteracting = true;
      stopAutoScroll();
    }, { passive: true });

    slider.addEventListener('touchend', () => {
      isInteracting = false;
      setTimeout(startAutoScroll, 2500);
    }, { passive: true });

    slider.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);

    updateControls();
    startAutoScroll();
  }

  initTestimonialsSlider();

  // Support Shopify customizer section reload
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && (e.target.querySelector('.corp-slider-wrap') || e.target.classList.contains('corp-hero-section'))) {
      initCorporateSlider();
    }
    if (e.target && (e.target.querySelector('.faq-accordion') || e.target.classList.contains('faq-section'))) {
      initFaqAccordion();
    }
    if (e.target && (e.target.querySelector('.testimonials-slider-wrap') || e.target.classList.contains('testimonials-section'))) {
      initTestimonialsSlider();
    }
  });

  
});
